<template>
    <aside class="c-sidebar">
        <ul class="c-sidebar__items">
            <li
                v-for="(item,index) in items"
                :key="item.id"
                class="c-sidebar__item"
                :class="{'active-item ' : current === item.id }"
                @click="setCurrent(item.id , index)"
            >
                <p>
                    {{ item.title }}
                </p>
                <img
                    v-if="item.image"
                    :src="item.image[0].link"
                    :alt="item.title"
                >
            </li>
        </ul>
    </aside>
</template>

<script >

    export default {
        name: 'Sidebar',

        props: {
            items       : Array,
            defaultValue: String,
        },

        /**
         * @inheritdoc
         */
        data() {
            return {
                current: this.defaultValue,
            };
        },

        watch: {
            /**
             * watch ghanges of default value
             * 
             * @param {*} val 
             */
            defaultValue(val) {
                this.current = val;
            },
        },

        methods: {
            /**
             * set the Id of selected item
             *
             * @param {string} id
             * @param {number} index
             */
            setCurrent(id, index) {
                this.current = id;
                this.$emit('sidebar-order-option', index);
            },

        },
    };

</script>

<style lang="scss" src="./sidebar.scss"/>
